import React, { useEffect, useState, useRef } from 'react';
import AppGetIcon from '../../AppGetIcon';
import styles from './AppNavbarDropdown.module.css';

export interface IOption {
  value: string;
  label: string;
}

interface AppNavbarDropdownProps {
  itemName: string;
  options: IOption[];
  modelValue: string;
  onUpdate: (value: string) => void;
  searchable?: boolean;
}

const AppNavbarDropdown: React.FC<AppNavbarDropdownProps> = ({
  itemName,
  options,
  modelValue,
  onUpdate,
  searchable = false,
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedOption = options.find(opt => opt.value === modelValue);

  const filteredOptions = options.filter((item) =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.navbarDropdownWrapper} ref={dropdownRef}>
      <button className={styles.navbarButton} onClick={() => setOpen(prev => !prev)}>
        <span className={styles.label}>{selectedOption?.label || itemName}</span>
        <AppGetIcon name="arrow-down" className={`${styles.icon} ${open ? styles.rotate : ''}`} />
      </button>

      {open && (
        <div className={styles.dropdownMenu}>
          {searchable && (
            <div className={styles.searchContainer}>
              <AppGetIcon name="search" className={styles.searchIcon} fillColor='var(--color-primary-main)'/>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={`${'Buscar'}...`}
                className={styles.searchInput}
              />
            </div>
          )}

          <div className={styles.optionsContainer}>
            {filteredOptions.map(option => (
              <div key={option.value} className={styles.option}>
                <input
                  type="radio"
                  className={styles.radioInput}
                  id={`navbar-${option.value}`}
                  value={option.value}
                  checked={option.value === modelValue}
                  onChange={() => {
                    onUpdate(option.value);
                    setOpen(false);
                  }}
                  name="navbar-radio-group"
                />
                <label htmlFor={`navbar-${option.value}`} className={styles.optionLabel}>
                  <span className={styles.radioCustom}></span>
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AppNavbarDropdown;
